$( document ).ready(function() {

//  FNB INTEREST RATES START 
  
 var months = $('input[name="fnb-ppm"]:checked').val();
  var price = parseInt(document.getElementsByClassName("price__regular")[0].innerText.replace("R ","").replace(",","").replace(".","")) / 100;
  var amount_with_int = (price + price*.0750).toFixed(2);
  if(months == 12) {
    
     var emi = ((price * (0.1175/12)) / (1 -((1 + (0.1175/12))**(-1 * 12 * 1)))).toFixed(2);
    
	var emi2 = ((price * (0.1375/12)) / (1 -((1 + (0.1375/12))**(-1 * 12 * 1)))).toFixed(2);

      var consoles = ((price * (0.02/12)) / (1 -((1 + (0.02/12))**(-1 * 12 * 1)))).toFixed(2);
    
//   	var emi = ((0.075/12*price)/0.06741653415).toFixed(2);
//     old
//     var emi2 = (((0.075 + 0.02)/12*price)/0.06741653415).toFixed(2);
  } else {
    
     var emi = ((price * (0.1175/12)) / (1 -((1 + (0.1175/12))**(-1 * 12 * 2)))).toFixed(2);
    
       var emi2 = ((price * (0.1375/12)) / (1 -((1 + (0.1375/12))**(-1 * 12 * 2)))).toFixed(2);

     var consoles = ((price * (0.02/12)) / (1 -((1 + (0.02/12))**(-1 * 12 * 2)))).toFixed(2);
    
//     var emi = ((0.075/12*price)/0.1302880792).toFixed(2);
//     old
//     var emi2 = (((0.075 + 0.02)/12*price)/0.1302880792).toFixed(2);
    console.log(emi);
  }
//   var emi = (amount_with_int/months).toFixed(2);
  $('amount.amount').text(emi);
  $('amount.amount2').text(emi2);

  $('.twelveplus').html('R'+consoles);
  $('.twentyplus').html('R'+consoles);
  
  
  var fnbrad = document.getElementsByClassName("fnb-ppm-radio");
  
  console.log(fnbrad);
  
  
  for(var loop = 0; loop < fnbrad.length; loop++){
  
  fnbrad[loop].onclick = function(){
    
    var months = this.value;
    console.log(months);
    var price = document.getElementsByClassName("price__regular")[0].innerText.replace("R ","").replace(",","").replace(".","") / 100;
    
    console.log(price);
    
//     var amount_with_int = (price + price*.0750).toFixed(2);
    if(months == 12) {
    
     var emi = ((price * (0.1175/12)) / (1 -((1 + (0.1175/12))**(-1 * 12 * 1)))).toFixed(2);
      
      console.log(((price * (0.1175/12)) / (1 -((1 + (0.1175/12))**(-1 * 12 * 1)))).toFixed(2));
    
	var emi2 = ((price * (0.1375/12)) / (1 -((1 + (0.1375/12))**(-1 * 12 * 1)))).toFixed(2);

       var consoles = ((price * (0.02/12)) / (1 -((1 + (0.02/12))**(-1 * 12 * 1)))).toFixed(2);

      $('.amnt.twelve').css('display','inline');
      $('.twelveplus').html('R'+consoles);
      $('.amnt.twentyfour').css('display','none');
    
//   	var emi = ((0.075/12*price)/0.06741653415).toFixed(2);
//     old
//     var emi2 = (((0.075 + 0.02)/12*price)/0.06741653415).toFixed(2);
      // console.log(price);
      //  console.log(emi);
  } else {
    
     var emi = ((price * (0.1175/12)) / (1 -((1 + (0.1175/12))**(-1 * 12 * 2)))).toFixed(2);
    
       var emi2 = ((price * (0.1375/12)) / (1 -((1 + (0.1375/12))**(-1 * 12 * 2)))).toFixed(2);
       var consoles = ((price * (0.02/12)) / (1 -((1 + (0.02/12))**(-1 * 12 * 2)))).toFixed(2);
    console.log(price);
//     var emi = ((0.075/12*price)/0.1302880792).toFixed(2);
//     old
//     var emi2 = (((0.075 + 0.02)/12*price)/0.1302880792).toFixed(2);
   
//     var emi = (amount_with_int/months).toFixed(2);

      $('.amnt.twentyfour').css('display','inline');
      $('.twentyplus').html('R'+consoles);
      $('.amnt.twelve').css('display','none');
  }
    $('amount.amount').text(emi);
    $('amount.amount2').text(emi2);
  };
    
  }
  
  //  FNB INTEREST RATES END 

});
  